import { ConfirmationService } from '@core/services/helpers/confirmation.service';
import { RealtimePresenceTexts } from '@services/realtime/realtime-presence-text';
import { Observable } from 'rxjs';

/**
 * Confirmação de "Recarregar" quando a tela tem alteração não salva (card 3496). Mesmo texto para
 * todas as telas com tempo real; só muda o item ("a demanda", "o deal").
 * @param actorName quem salvou do outro lado, quando se sabe
 */
export function confirmRealtimeReload(
  confirmationService: ConfirmationService,
  texts: RealtimePresenceTexts,
  actorName?: string | null
): Observable<boolean> {
  const description = actorName
    ? `Você tem alterações não salvas ${texts.inSubject}. Ao recarregar, elas serão perdidas e a tela mostrará a versão salva por ${actorName}.`
    : `Você tem alterações não salvas ${texts.inSubject}. Ao recarregar, elas serão perdidas e a tela mostrará a versão salva.`;

  return confirmationService.confirm(
    texts.reloadConfirmTitle,
    description,
    'danger',
    'Continuar editando',
    'Recarregar e perder alterações'
  );
}
